import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { AlertIcon } from '../../assets/imageAssets';
import { closeModal, openModals } from "../../redux/modal.slice";
import { usePausePaymentMutation } from '../../api/mutations/payment.query';
import ModalsEnum from '../../enums/modal.enum';
import Loader from '../../components/Loader';
import { useQueryClient } from '@tanstack/react-query';

const PauseSubscriptionModal = ({modalData}) => {
    const dispatch = useDispatch();
    const queryClient = useQueryClient();
    const user = useSelector((state) => state.me.data);
    const { mutate, isPending } = usePausePaymentMutation();
    const isPauseScheduled = user?.user_premium_status?.pause_scheduled;
    const premiumEnd = user?.user_premium_status?.billing?.renewal_date
        ? new Date(user.user_premium_status.billing.renewal_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
        : null;

    const handleClose = () => {
        dispatch(closeModal());
    }

    const handleConfirmPause = () => {
        mutate(undefined, {
            onSuccess: () => {
                queryClient.invalidateQueries(['user-info']);
                dispatch(closeModal());
                dispatch(
                    openModals({
                        modalIds: [ModalsEnum.SUBSCRIPTION_CANCELED_MODAL],
                        modalData: [
                            {
                                className: 'small-centered-modal',
                                type: 'pause',
                            }
                        ]
                    })
                );
            },
        });
    }

    return (
        <>
            <div className="modal-body">
                <div className='icon warning'>
                    <img src={AlertIcon} alt="Alert Icon" />
                </div>
                <h2 className='mb-8'>Pause Subscription for 30 Days</h2>
                <p className='mb-20'>You will retain access to premium features and resume your plan automatically after 30 days.</p>
                <p className='mb-24'>{isPauseScheduled ? 'Pause start date' : 'Next billing date'}: <strong>{premiumEnd || 'N/A'}</strong></p>
                <button className='primary-button mb-12' onClick={handleConfirmPause} disabled={isPauseScheduled}>Pause Subscription</button>
                <button className='outline-button' onClick={handleClose}>Close</button>
            </div>
            {isPending && <Loader />}
        </>
    );
}

export default PauseSubscriptionModal;